import { Sparkles } from "lucide-react";
import { DISTINTIVOS } from "../lib/content";

export default function Distintivos() {
  return (
    <section
      id="distintivos"
      data-testid="distintivos-section"
      className="relative bg-[var(--ms-ink)] text-white py-24 md:py-32 lg:py-40 overflow-hidden grain"
    >
      <div className="pointer-events-none absolute top-0 right-0 w-[600px] h-[600px] rounded-full blur-3xl opacity-20"
           style={{ background: "radial-gradient(circle, #7030A0 0%, transparent 70%)" }} />
      <div className="pointer-events-none absolute bottom-0 left-0 w-[500px] h-[500px] rounded-full blur-3xl opacity-15"
           style={{ background: "radial-gradient(circle, #A370AF 0%, transparent 70%)" }} />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
        {/* Section header */}
        <div className="flex items-center gap-3 mb-10">
          <span className="font-body uppercase text-[11px] tracking-[0.32em] text-[var(--ms-lila)] font-bold">
            05 / Distintivos
          </span>
          <span className="flex-1 h-px bg-white/15" />
        </div>

        <div className="grid grid-cols-12 gap-6 lg:gap-12 mb-16">
          <h2
            data-testid="distintivos-heading"
            className="col-span-12 md:col-span-8 font-display font-medium text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight"
          >
            Distintivos{" "}
            <span className="font-editorial italic font-light text-[var(--ms-lila)]">
              Sublimes.
            </span>
          </h2>
          <p className="col-span-12 md:col-span-4 md:pt-6 font-body text-base md:text-lg leading-[1.75] text-white/65">
            Cinco principios que definen cómo trabajamos y cómo entregamos resultados que dominan el mercado.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {DISTINTIVOS.map((d, i) => (
            <article
              key={d.title}
              data-testid={`distintivo-card-${i}`}
              className="relative group p-7 md:p-8 rounded-2xl border border-white/10 overflow-hidden transition-all duration-500 hover:-translate-y-1 min-h-[280px]"
            >
              {/* Background image */}
              <img
                src={d.image}
                alt=""
                aria-hidden="true"
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover scale-105 group-hover:scale-110 transition-transform duration-[900ms]"
              />
              {/* Brand purple #7030A0 transparency */}
              <div
                className="absolute inset-0"
                style={{ backgroundColor: "rgba(112, 48, 160, 0.55)" }}
              />
              {/* Subtle dark veil for legibility */}
              <div className="absolute inset-0 bg-black/15" />
              {/* Bottom-weighted gradient: keeps title/description readable without crushing the imagery */}
              <div
                className="absolute inset-0"
                style={{
                  background:
                    "linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.10) 30%, rgba(13,13,13,0.75) 100%)",
                }}
              />

              <div className="relative h-full flex flex-col">
                <div className="flex items-center justify-between mb-7">
                  <span className="font-display text-sm text-white/70">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <Sparkles size={16} className="text-[var(--ms-lila)] opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                </div>

                <h3 className="font-display font-medium text-2xl md:text-[26px] leading-tight tracking-tight mb-4 text-white drop-shadow-[0_2px_12px_rgba(0,0,0,0.5)]">
                  {d.title}
                </h3>

                <p className="font-body text-sm md:text-[15px] leading-relaxed text-white/85">
                  {d.desc}
                </p>

                <div className="mt-auto pt-6">
                  <div className="h-px w-full bg-gradient-to-r from-transparent via-[var(--ms-lila)] to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
